module.exports = __webpack_public_path__ + "static/assets/ab6fe6b4f8ff7db5f4efa7a534c86527.gif";